import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import IconButton from '@material-ui/core/IconButton';
import {PowerState} from '../../../constants/enums';
import {ReactComponent as speakerNew} from '../../../assets/images/studio/speaker-new.svg'

@observer
class LooperPower extends Component {
    render() {
        const {onClick, powerState, color, backgroundColor, disabled, className, onMouseOver, onMouseLeave} = this.props;
        return (
            <div className={`flexbox flex-center m-r-5 power ${className || ''}`}>
                <IconButton onMouseOver={onMouseOver} onMouseLeave={onMouseLeave}
                    className={`btn-power ${disabled ? 'disabled' : ''}`} disableRipple={true}
                    style={{color, backgroundColor}} onClick={onClick}>
                    {powerState === PowerState.On ? speakerNew.render() : speakerNew.render()}
                </IconButton>
            </div>
        );
    }
}

LooperPower.propTypes = {
    onClick: PropTypes.func,
    powerState: PropTypes.number,
    color: PropTypes.string,
    className: PropTypes.string,
    disabled: PropTypes.bool,
};

export default LooperPower;
